var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaitingForMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 100,
    fill: "#E7EBF2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.466 44.7305H-88.0137V39.6358C-88.0137 37.9789 -86.6705 36.6358 -85.0137 36.6358H92.466C94.1229 36.6358 95.466 37.9789 95.466 39.6358V44.7305Z",
    fill: "#0B0754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.466 44.7305H-88.0137V156.83C-88.0137 160.143 -85.3274 162.83 -82.0137 162.83H89.466C92.7797 162.83 95.466 160.143 95.466 156.83V44.7305Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.466 44.7305H-88.0137V55.7916H95.466V44.7305Z",
    fill: "#E9EEF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5359 48.7712H-17.4185C-18.2401 48.7712 -18.9062 49.4373 -18.9062 50.259C-18.9062 51.0807 -18.2402 51.7468 -17.4185 51.7468H47.5359C48.3576 51.7468 49.0237 51.0807 49.0237 50.259C49.0237 49.4373 48.3576 48.7712 47.5359 48.7712Z",
    fill: "#D8DDEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -17.3083,
    y: 70.6206,
    width: 54.8839,
    height: 11.4341,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16.8083,
    y: 71.1206,
    width: 53.8839,
    height: 10.4341,
    rx: 1.5,
    stroke: "#0B0754",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -17.3083,
    y: 88.9153,
    width: 54.8839,
    height: 11.4341,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16.8083,
    y: 89.4153,
    width: 53.8839,
    height: 10.4341,
    rx: 1.5,
    stroke: "#0B0754",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -17.3083,
    y: 107.209,
    width: 54.8839,
    height: 11.4341,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16.8083,
    y: 107.709,
    width: 53.8839,
    height: 10.4341,
    rx: 1.5,
    stroke: "#0B0754",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -9.51758,
    y: 125.504,
    width: 39.3022,
    height: 11.4341,
    rx: 2,
    fill: "#257CFFff"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 79.4827,
    cy: 40.6822,
    r: 1.49667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.6803,
    cy: 40.6822,
    r: 1.49667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.8775,
    cy: 40.6822,
    r: 1.49667,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M156.921 49.1709H113.046C109.779 49.1709 107.129 51.825 107.129 55.0965V128.222V144.903C107.129 148.202 109.807 150.828 113.046 150.828H156.921C160.188 150.828 162.838 148.183 162.838 144.903V71.786V55.1057C162.838 51.7973 160.151 49.1709 156.921 49.1709Z",
    fill: "#0B0754"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.651 54.052C123.651 53.0019 122.799 52.1506 121.749 52.1506H113.191C111.424 52.1506 109.991 53.5833 109.991 55.3506V144.116C109.991 145.883 111.424 147.316 113.191 147.316H156.767C158.535 147.316 159.967 145.883 159.967 144.116V55.3506C159.967 53.5833 158.535 52.1506 156.767 52.1506H148.292C147.242 52.1506 146.39 53.0019 146.39 54.052C146.39 55.1021 145.539 55.9534 144.489 55.9534H125.552C124.502 55.9534 123.651 55.1021 123.651 54.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.65,
    y: 73.3813,
    width: 34.6666,
    height: 9.33333,
    rx: 2,
    fill: "#F6F9FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.9,
    y: 73.6313,
    width: 34.1666,
    height: 8.83333,
    rx: 1.75,
    stroke: "#0B0754",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.736,
    y: 76.7385,
    width: 20.2851,
    height: 2.61879,
    rx: 1.30939,
    fill: "#E0E4F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.65,
    y: 88.0481,
    width: 34.6666,
    height: 9.33334,
    rx: 2,
    fill: "#F6F9FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.9,
    y: 88.2981,
    width: 34.1666,
    height: 8.83334,
    rx: 1.75,
    stroke: "#0B0754",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.736,
    y: 91.4053,
    width: 10.4822,
    height: 2.61879,
    rx: 1.3094,
    fill: "#E0E4F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.65,
    y: 102.715,
    width: 34.6666,
    height: 9.33333,
    rx: 2,
    fill: "#F6F9FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.9,
    y: 102.965,
    width: 34.1666,
    height: 8.83333,
    rx: 1.75,
    stroke: "#0B0754",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.736,
    y: 106.072,
    width: 25.4589,
    height: 2.61879,
    rx: 1.3094,
    fill: "#E0E4F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.094,
    y: 53.1245,
    width: 9.33333,
    height: 0.799995,
    rx: 0.399998,
    fill: "#5A578A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.121,
    y: 53.1245,
    width: 0.800034,
    height: 0.799995,
    rx: 0.399998,
    fill: "#5A578A"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 117.229,
    y: 132.122,
    width: 35.6184,
    height: 10.3601,
    rx: 3,
    fill: "#257CFFff"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 64.1338,
    y: 69,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#257CFFff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3816 107.446L87.586 111.242C86.0124 112.815 83.4641 112.815 81.8918 111.242C80.3193 109.67 80.3193 107.121 81.8915 105.549L89.484 97.9563C91.0563 96.384 93.6048 96.384 95.1771 97.9563C95.7012 98.4804 96.5511 98.4804 97.0752 97.9563C97.5993 97.4322 97.5993 96.5823 97.0752 96.0582C94.4546 93.4376 90.2065 93.4376 87.586 96.0582L79.9935 103.651C77.3729 106.271 77.3729 110.519 79.9935 113.14C82.6138 115.762 86.8621 115.762 89.4841 113.14L93.2797 109.344C93.8038 108.82 93.8038 107.97 93.2797 107.446C92.7556 106.922 91.9057 106.922 91.3816 107.446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.274 94.3489C110.894 91.7284 110.894 87.4803 108.274 84.8597C105.653 82.2392 101.405 82.2392 98.7834 84.8594L94.2292 89.4136C93.705 89.9377 93.705 90.7876 94.2292 91.3117C94.7533 91.8358 95.6031 91.8358 96.1272 91.3117L100.681 86.7578C102.254 85.1855 104.803 85.1855 106.376 86.7578C107.948 88.33 107.948 90.8786 106.376 92.4508L98.0248 100.802C96.4524 102.374 93.904 102.374 92.3317 100.802C91.8076 100.278 90.9578 100.278 90.4336 100.802C89.9095 101.326 89.9095 102.176 90.4336 102.7C93.0542 105.32 97.3023 105.32 99.9228 102.7L108.274 94.3489Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -102.014,
    y: 36.6357,
    width: 211.48,
    height: 154.194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.2 0 0 0 0 0.380392 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: -17.5176,
    y: 122.504,
    width: 55.3022,
    height: 27.4341,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054375 0 0 0 0 0.199667 0 0 0 0 0.483333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 104.936,
    y: 126.148,
    width: 58.6667,
    height: 29.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054375 0 0 0 0 0.199667 0 0 0 0 0.483333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 83.8036,
    y1: 109.007,
    x2: -63.6126,
    y2: 109.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 100,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingForMobile);
export default __webpack_public_path__ + "static/media/waiting_for_mobile.7d4c4e37d2f631ce281ef56c03e41fc1.svg";
export { ForwardRef as ReactComponent };